import { type Profile, api } from '@here/api'

export const updateProfile = async (profile: Partial<Profile>) => {
	if (!profile.id) {
		return
	}

	const { data, error } = await api()
		.from('profile')
		.update({
			username: profile.username,
		})
		.eq('id', profile.id)

	if (error) {
		console.error(error)
		throw new Error(error.message)
	}

	return data
}

export const updateProfilePicture = async ({
	file,
	id,
}: { file: File; id: string }) => {
	const ext =
		file.type === 'image/png' ? 'png' : file.type === 'image/jpeg' ? 'jpg' : null

	if (!ext) {
		throw new Error('Unsupported file type. Only PNG and JPG are allowed.')
	}

	const filePath = `${id}.${ext}`

	// Clean up the other extension if it exists
	const otherExt = ext === 'png' ? 'jpg' : 'png'
	const otherPath = `${id}.${otherExt}`

	const { error: deleteError } = await api()
		.storage.from('profile-images')
		.remove([otherPath])

	if (deleteError && deleteError.message !== 'The resource was not found') {
		console.warn(`Failed to delete old profile image (${otherPath}):`, deleteError)
		// not fatal, just warn
	}

	const { error: uploadError } = await api()
		.storage.from('profile-images')
		.upload(filePath, file, {
			upsert: true,
			contentType: file.type,
			cacheControl: '3600',
		})

	if (uploadError) {
		console.error('Upload error:', uploadError)
		throw new Error(uploadError.message)
	}

	return filePath
}
